import { AspectRatio as ChakraAspectRatio } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type AspectRatioProps = ComponentPropsWithRef<typeof ChakraAspectRatio>;

export function AspectRatio(props: AspectRatioProps) {
  return <ChakraAspectRatio {...props} />;
}
